import { render, staticRenderFns } from "./createAsk.vue?vue&type=template&id=c3284572&scoped=true"
import script from "./createAsk.vue?vue&type=script&lang=js"
export * from "./createAsk.vue?vue&type=script&lang=js"
import style0 from "./createAsk.vue?vue&type=style&index=0&id=c3284572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3284572",
  null
  
)

export default component.exports